import React from "react";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import {
  translationConstants,
  UserVerificationApprovalStatus,
} from "../../../constants";
import logout from "../../../assets/images/icon/logout.svg";
import TextSwitchButton from "../SwitchButton/TextSwitchButton";
import instructor from "../../../assets/images/icon/instructor.jpg";
import SwitchButton from "../SwitchButton/SwitchButton";

const SidebarFooter = ({
  roles,
  userRole,
  userData,
  isShowInstructorButton = false,
  sidebarOpen = false,
  isChecked = false,
  handleProfileToggle = false,
  openModal,
  handleLogout,
}) => {
  const { t } = useTranslation();
  return (
    <section id="sideBarBottom" className="mt-auto">
      {userRole === roles.Practioner &&
        userData?.instructorStatus !==
          UserVerificationApprovalStatus.Disabled &&
        isShowInstructorButton(userRole, userData) && (
          <div>
            {sidebarOpen ? (
              <div className="mt-2 mx-2">
                <Row>
                  <Col xs="12">
                    <button
                      className="success-button p-2"
                      type="button"
                      onClick={openModal}
                    >
                      {t(translationConstants.BecomeInstructor)}
                    </button>
                  </Col>
                </Row>
              </div>
            ) : (
              <Row>
                <Col xs="12">
                  <img
                    src={instructor}
                    height={40}
                    width={35}
                    alt=""
                    className="cursor-pointer"
                    onClick={openModal}
                  />
                </Col>
              </Row>
            )}
          </div>
        )}
      {userRole === roles.Instructor ||
      (userRole === roles.Practioner &&
        userData?.instructorStatus ===
          UserVerificationApprovalStatus.Disabled) ||
      userRole === roles.FreelanceInstructor ? (
        <div>
          {sidebarOpen ? (
            <div className="mt-2">
              <label id="switchProfile" className="mx-1">
                {t(translationConstants.switchprofile)}
              </label>
              <Row>
                <Col xs="12">
                  <TextSwitchButton
                    isChecked={isChecked}
                    handleToggleSwitch={handleProfileToggle}
                    firstValue={translationConstants.instructor}
                    secondValue={translationConstants.PRACTITIONER}
                  />
                </Col>
              </Row>
            </div>
          ) : (
            <div className="mb-3">
              <Row>
                <Col xs="12">
                  <SwitchButton
                    isChecked={isChecked}
                    handleSwitchToggle={handleProfileToggle}
                  />
                </Col>
              </Row>
            </div>
          )}
        </div>
      ) : null}

      <div className=" mt-2 mx-2 my-2 px-2">
        <Row onClick={handleLogout} style={{ cursor: "pointer" }}>
          <Col
            xs={"12"}
            className={`d-flex align-items-center ${
              !sidebarOpen && "justify-content-center"
            } 
        `}
          >
            <img alt="side-bar" height={18} width={18} src={logout} />
            <span className="logoutSidebar text-nowrap">
              {t(translationConstants.logout)}
            </span>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default SidebarFooter;
